// removed by extract-text-webpack-plugin
module.exports = {"gwCoverages__coverage":"CoveragesList-hashed__gwCoverages__coverage__ZAgoi","gwCoverages__coverage_first":"CoveragesList-hashed__gwCoverages__coverage_first__3ANpS","gwCoverages__coverageHeading":"CoveragesList-hashed__gwCoverages__coverageHeading__3XZ7Z"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/coveragesList/CoveragesList-hashed.scss
// module id = 1228
// module chunks = 0